<template>
  <!--div class="pm-dialog-boardside-type"-->
  <div>
    <div class="flex justify-center outer-area">
      <div
        class="candidate-list vsChipOutside"
        v-for="(master, index) in masterList"
        :key="index"
        @mousedown="
          selectedId = selectedId !== master.id ? master.id : LABEL_UNSELECTED
        "
      >
        <vs-chip
          class="vsChip"
          :color="selectedId === master.id ? '#346c88' : '#828282'"
        >
          {{ masterList.find((el) => el.id === master.id).label }}
          <feather-icon
            v-if="master.id === LEFT_REFRESH || master.id === RIGHT_REFRESH"
            icon="RefreshCwIcon"
            svgClasses="h-4 w-4"
            class="pm-boardside-type-icon"
          />
        </vs-chip>
      </div>
    </div>

    <div class="flex justify-center">
      <vs-button class="button" color="#2E87B9" @mousedown="closePopup">
        <span class="button-text">キャンセル</span>
      </vs-button>
      <vs-button
        class="button"
        color="#2E87B0"
        @mousedown="onSubmit(isUpdateTimeStamp)"
      >
        <span class="button-text">保存 </span>
      </vs-button>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("gkmgPortMasterDestinationWork");
import { BOARDSIDE_TYPE_MASTERLIST } from "@/config/const.js";
import moment from "moment-timezone";

export default {
  props: {
    taskId: { type: String, required: true },
    columnKey: { type: String, required: true },
    valueMap: { required: true },
    closePopup: { type: Function, required: true },
  },
  data() {
    return {
      selectedId: -1,
      isUpdateTimeStamp: null,
      LABEL_UNSELECTED: -1,
      LEFT_REFRESH: 3,
      RIGHT_REFRESH: 4,
    };
  },
  watch: {
    taskId() {
      this.initData();
    },
    summaryDialogShowPopup() {
      if (this.summaryDialogShowPopup === true) {
        this.initData();
      }
    },
  },
  computed: {
    ...mapState({
      summaryDialogShowPopup: (state) => state.summaryDialogShowPopup,
    }),
    masterList() {
      return BOARDSIDE_TYPE_MASTERLIST;
    },
    enableSave() {
      return true;
    },
    isValueSelected() {
      if (this.masterList.map((el) => el.id).includes(this.selectedId)) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    initData() {
      this.selectedId = this.valueMap.itSelf ? this.valueMap.itSelf.id : null;
      this.isUpdateTimeStamp = !!(this.selectedId || this.valueMap.changes);
    },
    onSubmit(isUpdateTimeStamp) {
      /*
       * onSubmit(false)    : 保存
       * onSubmit(true)     : ハイライト保存
       */
      let mode = [];
      if (isUpdateTimeStamp) mode.push("updateTimeStamp");
      const updateKeyValueMap = {};
      updateKeyValueMap[this.columnKey] = {
        id: this.isValueSelected ? this.selectedId : null,
        label: this.isValueSelected
          ? this.masterList.find((el) => el.id === this.selectedId).saveValue
          : null,
      };
      updateKeyValueMap["updated_at"] = new Date(
        moment().local().format("YYYY-MM-DD HH:mm:ss"),
      );
      this.$emit("updateValue", this.taskId, updateKeyValueMap, mode);
    },
  },
  mounted() {
    this.initData();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/port-master/_variables.scss";
.pm-dialog-boardside-type {
  .outer-area {
    padding: 1rem;
  }
  .candidate-list {
    margin: 0.2rem;
    padding: 0rem;
    .con-vs-chip {
      border-radius: 6px;
      height: 3rem;
      font-size: 120%;
      min-width: 3rem;
    }
  }
  .pm-boardside-type-icon {
    padding-left: 0.4rem;
  }
}

.vsChipOutside {
  width: 4rem;
  height: 3rem;
  margin: 1rem;
}
.vsChip {
  border-radius: 10px;
  font-size: 16px;
  width: 4rem;
  height: 3rem;
}

.button {
  width: 230px;
  height: 46px;
  margin: 0 1rem;
  border-radius: 8px;
  cursor: pointer;
}
.button-text {
  width: 32px;
  height: 24px;

  font-family: "Hiragino Kaku Gothic Pro";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height */
  align-items: center;
  text-align: center;

  color: #f2f2f2;
}
</style>
